import { MapPin } from "lucide-react";
export default function SeoLocal() {
  return <section id="seo-local" className="bg-background py-32">
      <div className="container px-4 md:px-6">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="flex size-10 items-center justify-center rounded-lg bg-primary/10">
              <MapPin className="size-5 text-primary" />
            </div>
            <h3 className="text-3xl md:text-4xl font-semibold font-default text-foreground tracking-tight">
              Presença Estratégica
            </h3>
          </div>
          
          <div className="space-y-8 text-lg md:text-xl text-muted-foreground leading-relaxed">
            <p>
              Nosso escritório está estrategicamente localizado no coração financeiro e criativo do Brasil. Atendemos clientes de toda a região metropolitana de <strong className="bg-sidebar-accent text-foreground px-2 py-0.5 rounded-md font-semibold whitespace-nowrap">São Paulo</strong>, oferecendo soluções personalizadas com a agilidade e excelência que o mercado de alto nível exige.
            </p>
            
            <p>
              Com raízes fortes no vibrante bairro de <strong className="bg-sidebar-accent text-foreground px-2 py-0.5 rounded-md font-semibold whitespace-nowrap">Pinheiros</strong>, combinamos inovação constante com sólida tradição. Estar a poucos passos da <strong className="bg-sidebar-accent text-foreground px-2 py-0.5 rounded-md font-semibold whitespace-nowrap">Faria Lima</strong> nos permite manter um pulso constante nas principais tendências de negócios, garantindo que nossos parceiros estejam sempre um passo à frente em seus respectivos setores.
            </p>
          </div>
        </div>
      </div>
    </section>;
}